<template>
    <div class="dashboardOverview">
        <div class="doCont">
            <div class="doPortfolios">
                <div class="doTotal">
                    <div class="doTitleCont">
                        <div class="doTitle">{{ $t('Home.dashboard.overview.allPortfolios') }}</div>
                        <div class="pfHeadActions">
                            <HoldingsPieChartDialog></HoldingsPieChartDialog>
                            <ObjectivesOverviewDialog></ObjectivesOverviewDialog>
                        </div>
                    </div>
                    <div class="doValueCont">
                        <div class="doValueInfos">
                            <div class="doCurrency">{{ preferredCurrency }}</div>
                            <div class="doValue">{{ allPortfoliosTotal }}</div>
                        </div>
                        <ValueAndChange v-bind="totalChange" class="doChange"></ValueAndChange>
                    </div>
                </div>
                <div class="doMovers">
                    <div class="doSubtitle">{{ $t('Home.dashboard.overview.topMovers') }}</div>
                    <div class="overviewPortfolioCardList">
                        <OverviewPortfolioCard v-for="(s, i) in topPortfolioMovers" :stock="s" type="portfolio" :key="`tp${i}`" @viewStockLot="viewStockLot"></OverviewPortfolioCard>
                    </div>
                </div>
            </div>
            <div class="doLists" v-if="hasBestSuggestions">
                <div class="doTitle">{{ $t('Home.dashboard.overview.bestBuySuggestions') }}</div>
                <div class="doBests">
                    <OverviewListCard v-for="(s, i) in getTopBuys" :stock="s" type="buy" :key="`tb${i}`" @viewStock="viewStock"></OverviewListCard>
                </div>
                <div class="doTitle">{{ $t('Home.dashboard.overview.bestSellSuggestions') }}</div>
                <div class="doBests">
                    <OverviewListCard v-for="(s, i) in getTopSells" :stock="s" type="sell" :key="`ts${i}`" @viewStock="viewStock"></OverviewListCard>
                </div>
            </div>
            <PortfolioStockList></PortfolioStockList>
        </div>
        <ViewStockDialogMobile ref="viewStockDialog" @notify="showNotification"></ViewStockDialogMobile>
        <PortfolioEditStockDialog ref="portfolioEditStockDialog" :portfolioId="selectedPortfolioId" :stock="selectedPortfolioStock"></PortfolioEditStockDialog>
        <SySnackbar ref="iSySnackbar"></SySnackbar>
    </div>
</template>

<script>
import HoldingsPieChartDialog from '../../controls/HoldingsPieChartDialog.vue';
import ObjectivesOverviewDialog from '../../controls/ObjectivesOverviewDialog.vue';
import SySnackbar from '../../controls/SySnackbar.vue';
import PortfolioStockList from '../../portfolio/PortfolioStockList.vue';
import ViewStockDialogMobile from '../../stocks/ViewStockDialogMobile.vue';
import DashboardOverviewMixin from './DashboardOverviewMixin'
import OverviewListCard from './OverviewListCard.vue';
export default {
    mixins: [DashboardOverviewMixin],
    components: { OverviewListCard, ViewStockDialogMobile, SySnackbar, HoldingsPieChartDialog, ObjectivesOverviewDialog, PortfolioStockList }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/breakpoints.scss";
.dashboardOverview {
    font-family: "Roboto", sans-serif;
    padding: 10px;
    .doCont {
        display: flex;
        flex-direction: column;
        gap: 10px;
        color: #FFF;
        &>* {
            flex: 1;
        }
        .doLists {
            display: flex;
            flex-direction: column;
            gap: 5px;
            .doTitle {
                padding: 5px 10px;
            }
            .doBests {
                display: flex;
                gap: 10px;
                &>* {
                    flex: 0 0 calc(25% - 7.5px); // 4 cartes par ligne, moins le gap
                    max-width: calc(25% - 7.5px);
                }
            }
        }
        .doPortfolios {
            display: flex;
            flex-direction: column;
            color: #000;
            background-color: #FFF;
            padding: 5px;
            &>* {
                flex: 1;
            }
            .doTotal {
                display: flex;
                gap: 10px;
                justify-content: space-between;
                .doTitleCont {
                    font-size: 1em;
                    display: flex;
                    flex-direction: column;
                    .doTitle {
                        font-weight: 600;
                    }
                    .pfHeadActions {
                        display: flex;
                        gap: 15px;
                    }
                }
                .doValueCont {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-end;
                    .doValueInfos {
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        .doValue {
                            font-size: 1.8em;
                            font-weight: bold;
                        }
                        .doCurrency {
                            font-size: 0.8em;
                            color: #777;
                        }
                    }
                }
            }
            .doMovers {
                display: flex;
                flex-direction: column;
                gap: 5px;
                .doSubtitle {
                    font-size: 0.8em;
                    color: #777;
                }
                .overviewPortfolioCardList {
                    display: flex;
                    gap: 5px;
                    &>* {
                        flex: 1;
                    }
                }
            }
        }
    }
    @media screen and (max-width: $small) {
        padding: 0 10px;
    }
}
</style>